export default __webpack_public_path__ + "static/media/frontImage3.230b54a5.jpg";